import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendLadiesNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_237_14859",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 8,
		height: 14,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 14,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_237_14859)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 4.5,
				r: 2.75,
				stroke: "#FF537F",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 7.5V12",
				stroke: "#FF537F",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.5 10H6.5",
				stroke: "#FF537F",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			})
		]
	})]
});
export default SvgTrendLadiesNew;
